module.exports = __webpack_public_path__ + "bf868313a49a3716a2d69cee36b69e5a.jpg";